var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as BookingStepsActions from '../actions/booking-steps.actions';
import * as BookingStepsState from '../states/booking-steps.state';
import { BookingStep } from '@ibe/models/ui';
var State = /** @class */ (function (_super) {
    __extends(State, _super);
    function State() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return State;
}(BookingStepsState.State));
export { State };
var initialState = BookingStepsState.initialState;
/**
 *
 *
 * @export
 * @param {*} [state=initialState]
 * @param {BookingStepsActions.Actions} action
 * @returns {BookingStepsState.State}
 */
export function reducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case BookingStepsActions.ActionTypes.LOADING:
            state = Object.assign({}, state, { loading: true });
            return state;
        case BookingStepsActions.ActionTypes.PUT_BOOKINGSTEPS:
            state = Object.assign({}, state, __assign({ loading: false, orig_booking_steps: action.payload.booking_steps }, action.payload));
            return state;
        case BookingStepsActions.ActionTypes.PUT_STEPS:
            state = Object.assign({}, state, { loading: false, booking_steps: action.payload });
            return state;
        case BookingStepsActions.ActionTypes.PUT_CURRENTSTEP:
            state = Object.assign({}, state, { loading: false, current_step: action.payload });
            return state;
        case BookingStepsActions.ActionTypes.PUT_CURRENTPAGE:
            state = Object.assign({}, state, { loading: false, current_page: action.payload });
            return state;
        case BookingStepsActions.ActionTypes.PUT_BOOKINGTYPE:
            state = Object.assign({}, state, { loading: false, booking_type: action.payload });
            return state;
        case BookingStepsActions.ActionTypes.PUT_ALL_COSTS_PER_DAY:
            state = Object.assign({}, state, { costsPerDay: action.payload });
            return state;
        case BookingStepsActions.ActionTypes.PUT_TTT:
            state = Object.assign({}, state, { loading: false, timeToThink: action.payload });
            return state;
        case BookingStepsActions.ActionTypes.RESET_SELECTED_FLIGHT:
            var steps = state.booking_steps.slice();
            var newSteps_1 = [];
            steps.forEach(function (step) { return newSteps_1.push(Object.assign(new BookingStep(null, null), step, { flight_selected: false })); });
            state = Object.assign({}, state, { loading: false, booking_steps: newSteps_1, current_step: 0 });
            return state;
        case BookingStepsActions.ActionTypes.RESELECT_LAST_FLIGHT:
            var oldSteps = state.booking_steps.slice();
            var stepToChange = oldSteps[oldSteps.length - 1];
            oldSteps[oldSteps.length - 1] = Object.assign(new BookingStep(null, null), stepToChange, { flight_selected: false });
            state = Object.assign({}, state, { loading: false, booking_steps: oldSteps });
            return state;
        case BookingStepsActions.ActionTypes.RESET:
            state = Object.assign({}, state, initialState);
            return state;
        default:
            return state;
    }
}
export var getLoading = function (state) { return state.loading; };
export var getOrigBookingSteps = function (state) { return state.orig_booking_steps; };
export var getBookingSteps = function (state) { return state.booking_steps; };
export var getBookingCurrentStep = function (state) { return state.current_step; };
export var getBookingCurrentPage = function (state) { return state.current_page; };
export var getBookingType = function (state) { return state.booking_type; };
export var getCostsPerDay = function (state) { return state.costsPerDay; };
export var getTimeToThink = function (state) { return state.timeToThink; };
